// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + ({"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] || chunkId) + "." + {"162":"d9b4bba229e98a9646d1","189":"d586b7868d2e5b7f1262","404":"228cb1635ce66a7d2c56","406":"5443e906761358d79771"}[chunkId] + ".css";
};